import { useContext } from "react";
import configContext from 'src/contexts/ConfigContext';

export function useConfig(){
    return useContext(configContext);
}